export default __webpack_public_path__ + "static/media/success-activate-account.ac7a4887.svg";